module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//pet-box_3.png?v=fdaafbd4";